"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isLocalhost_1 = __importDefault(require("./isLocalhost"));
const isDevelopment = process.env.NODE_ENV !== 'production';
exports.default = isLocalhost_1.default
    ? 'http://localhost:8080'
    : isDevelopment
        ? 'https://dev-search.fondee.io'
        : 'https://search.fondee.io';
